import { faAnglesUp, faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '@orobix/orobix-fe-components'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { usePromoteAnnotation } from './usePromoteAnnotation'

interface PromoteAnnotationButtonProps {
  outcomeId: number
  promoted?: boolean
  disabled?: boolean
}

const PromoteAnnotationInLineButton = ({
  outcomeId,
  promoted = false,
  disabled = false,
}: PromoteAnnotationButtonProps) => {
  const { t } = useTranslation()

  const [label, setLabel] = useState('')
  const [title, setTitle] = useState('')
  const {
    promoteAnnotationByOutcome: promoteAnnotation,
    isPromoting,
  } = usePromoteAnnotation()
  const [isPromoted, setIsPromoted] = useState(promoted)

  useEffect(() => {
    if (isPromoting) {
      setLabel(t('Promoting...'))
      setTitle(t('Promoting prediction to ground truth...'))
    } else if (isPromoted) {
      setLabel(t('Promoted'))
      setTitle(t('Prediction already promoted to ground truth.'))
    } else {
      setLabel(t('Promote'))
      if (disabled) {
        setTitle(t('Prediction matches groung truth, nothing to promote.'))
      } else {
        setTitle(
          t(
            'Promote this prediction to annotation to use it as ground truth in trainings.'
          )
        )
      }
    }
  }, [t, disabled, isPromoted, isPromoting])

  return (
    <Button
      onClick={() => {
        promoteAnnotation(outcomeId)
        setIsPromoted(true)
      }}
      label={label}
      title={title}
      icon={<FontAwesomeIcon icon={isPromoted ? faCheck : faAnglesUp} />}
      buttonType="button"
      type="default"
      disabled={disabled || isPromoting || isPromoted}
      loading={isPromoting}
      block
    />
  )
}

export default PromoteAnnotationInLineButton
